<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <section class="card-style-sec ai-analyst-admin">
      <div class="ai-admin-tab-header">
        <div class="ai-admin-tab-title">
          <app-tab-main [links]="tabs"></app-tab-main>
        </div>
      </div>

      @if (section === 'enablement') {
        <app-analyst-enablement></app-analyst-enablement>
      }

      @if (section === 'success-metrics') {
        <app-ai-analyst-success-metrics></app-ai-analyst-success-metrics>
      }
    </section>
  </app-sidebar-layout>
</div>
